import React from 'react';
import styled from 'styled-components';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';
import * as AppActions from '../../../AppActions';
import HeroBannerSection from './HeroBannerSection';
import CreatorSection from './CreatorSection';
import BeltBannerSection from './BeltBannerSection';
import ProductSection from './ProductSection';
import ArticleSection from './ArticleSection';
import AboutSection from './AboutSection';

function Landing(props) {
  const {landing} = props;
  const [articles, setArticles] = React.useState(null);
  const [products, setProducts] = React.useState(null);
  const [creators, setCreators] = React.useState(null);

  const fetchArticles = React.useCallback(async () => {
    let articleIds = landing?.custom_layout.article_section.articles || [];
    let articles = [];

    let _articles = await JStorage.fetchDocuments(
      'Article_Default',
      {
        _id: {
          $in: [
            ...articleIds.map((id) => ({
              $oid: id,
            })),
          ],
        },
      },
      null,
      null,
      null,
      {anonymous: true},
    );

    for (let id of articleIds) {
      let a = _articles.find((p) => p.id === id);
      articles.push(a);
    }

    setArticles(articles);
  }, [landing]);

  const fetchProducts = React.useCallback(async () => {
    let productIds = landing?.custom_layout.product_section.products || [];
    let products = [];

    let _products = await JStorage.fetchDocuments(
      'product',
      {
        _id: {
          $in: [
            ...productIds.map((id) => ({
              $oid: id,
            })),
          ],
        },
      },
      null,
      null,
      null,
      {anonymous: true},
    );

    let creators = await JStorage.fetchDocuments(
      'creator',
      {
        labels: {
          $in: [
            ..._products.map((_p) =>
              _p.labels.find((label) => label.indexOf('創作者') > -1),
            ),
          ],
        },
      },
      null,
      null,
      null,
      {anonymous: true},
    );

    for (let id of productIds) {
      let p = _products.find((p) => p.id === id);
      let c = creators.find(
        (c) => p.labels.findIndex((label) => label === c.labels[0]) > -1,
      );
      products.push({...p, creator: {...c}});
    }

    setProducts(products);
  }, [landing]);

  const fetchCreators = React.useCallback(async () => {
    let creatorIds = landing?.custom_layout.creator_section.creators || [];
    let creators = [];

    let _creators = await JStorage.fetchDocuments(
      'creator',
      {
        $and: [
          {
            _id: {
              $in: [
                ...creatorIds.map((id) => ({
                  $oid: id,
                })),
              ],
            },
          },
          {public: true},
        ],
      },
      null,
      null,
      null,
      {anonymous: true},
    );

    for (let id of creatorIds) {
      let p = _creators.find((p) => p.id === id);
      !!p && creators.push(p);
    }

    setCreators(creators);
  }, [landing]);

  React.useEffect(() => {
    fetchArticles();
    fetchProducts();
    fetchCreators();
  }, [fetchArticles, fetchProducts, fetchCreators]);
  return (
    <Wrapper>
      <HeroBannerSection landing={landing} />
      <CreatorSection creators={creators} />
      <BeltBannerSection landing={landing} />
      <ProductSection products={products} />
      <ArticleSection articles={articles} />
      <AboutSection landing={landing} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background-color: var(--secondColor);
  min-height: var(--contentMinHeight);
  padding-top: var(--topNavBarHeight);

  & .title-container {
    padding: 40px 0px;
    text-align: center;

    & > h2 {
      font-size: 1.25rem;
      color: var(--primaryColor);
    }

    & > h3 {
      font-size: 1rem;
      color: var(--primaryColor);
    }

    @media screen and (max-width: 500px) {
      padding: 20px 0px;

      & > h2 {
        font-size: 1rem;
      }

      & > h3 {
        font-size: 0.75rem;
      }
    }
  }
`;

export default Landing;
